import React from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '@store/StoreProvider'
import { t } from '@store/I18nStore'
import './auth.css'

const PRIVACY_URL = 'https://policies.google.com/privacy'
const TERMS_URL = 'https://policies.google.com/terms'

export const RecaptchaNotice = observer(function RecaptchaNotice() {
  const { i18n } = useStore()
  void i18n.language
  void i18n.version

  const privacy = t('app.legal.privacy_policy')
  const terms = t('app.legal.terms_of_service')
  const notice = t('app.legal.recaptcha_notice', { privacy: '__PRIVACY__', terms: '__TERMS__' })
  const [beforePrivacy = '', afterPrivacy = ''] = notice.split('__PRIVACY__')
  const [mid = '', afterTerms = ''] = afterPrivacy.split('__TERMS__')

  return (
    <p className="recaptcha-notice">
      {beforePrivacy}
      <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
        {privacy}
      </a>
      {mid}
      <a href={TERMS_URL} target="_blank" rel="noreferrer">
        {terms}
      </a>
      {afterTerms}
    </p>
  )
})
